<template>
    <div class="summary-card" :class="variantClass">
        <span class="summary-label">{{ label }}</span>
        <strong class="summary-value">{{ value }}</strong>
    </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
    label: String,
    value: [String, Number],
    variant: {
        type: String,
        default: 'default'
    }
});

const variantClass = computed(() => `summary-${props.variant}`);
</script>

<style scoped>
.summary-card {
    border: 1px solid #dbe4ee;
    border-radius: 5px;
    background: #f8fbff;

    display: flex;
    flex-direction: column;
    justify-content: center;

    padding: 4px 6px;
    gap: 2px;
    line-height: 1; 
}

.summary-label {
    font-size: 11px;
    color: #64748b;
    line-height: 1;
    margin: 0;
}

.summary-value {
    font-size: 16px;
    font-weight: bold;
}

/* Variantes */
.summary-success { background: #e6f7ec; }
.summary-warning { background: #fff6e5; }
.summary-danger { background: #fdecea; }
.summary-default { background: #f8fbff; }
</style>